import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { RulesetBooleanRuleCard } from '../../Notification/Rulesets/BooleanRuleCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const RulesetBooleanRuleCardWidget = () => {
    const component = useMemo(() => (_jsx(RulesetBooleanRuleCard, { booleanRule: {
            name: 'Boolean rule',
            enabled: true,
            deviceEnabledType: '',
            key: '',
            triggeringValue: false,
        }, metricKeysEnum: {}, ruleAttributes: {}, userAttributes: {}, setBooleanRule: (booleanRule) => {
            // set this Boolean rule in the parent ruleset here
        }, removeArrayObjectNInParent: () => {
            // remove this Boolean rule from the parent ruleset here
        } })), []);
    return {
        name: 'RulesetBooleanRuleCard',
        category: 'common',
        component,
    };
};
